// Single registry for every localStorage key the app uses. Values are plain
// strings (callers own parsing); keys are namespaced under "liftnotes.".
// Legacy (pre-registry) keys are read once as a fallback so nothing resets.

const PREFIX = "liftnotes.";

export const storageKeys = {
  theme: "theme",
  sessionRestSeconds: "session-rest-seconds",
  exerciseMetric: (exerciseName: string) => `metric.${exerciseName}`,
} as const;

export function storageGet(key: string, legacyKey?: string): string | null {
  const value = localStorage.getItem(PREFIX + key);
  if (value !== null) return value;
  if (legacyKey) return localStorage.getItem(legacyKey);
  return null;
}

export function storageSet(key: string, value: string) {
  localStorage.setItem(PREFIX + key, value);
}
